module.exports = __webpack_public_path__ + "img/Produktion PS1.f8111aaf.webp";